import React from "react";
import { useTranslation } from "react-i18next";
import imageBadgePlus from "../../../assets/img/directsearch/badge_plus.avif";

const PlusModal = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center gap-4 px-6 pb-10 lg:pt-10">
      <img
        src={imageBadgePlus}
        role="presentation"
        className="size-14 shrink-0"
        alt="badge"
      />
      <h3 className="text-sm font-medium mb-0 text-center">
        {t("ds.badge_modal_title")}
      </h3>
      <div className="flex flex-col gap-4">
        <p className="text-xs font-medium text-black/60">
          {t("ds.badge_modal_subtitle.0")}
        </p>
        <p className="text-xs font-medium text-black/60">
          {t("ds.badge_modal_subtitle.1")}
        </p>
      </div>
    </div>
  );
};

export default PlusModal;
